import React, { useEffect, useState } from "react";
import TableCustom from "../../../../components/table/tableCustom";
import TableRowCommon from "../../../../components/table/TableRowCommon";
import { NavigateFunction, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { dateTimeToView } from "../../../../utils/date.utils";
import { routeName } from "../../../../routes/routeName";
import { icons } from "../../../../assets/icons/icons";
import { MenuItem } from "@mui/material";
import FilterSelect from "../../../../components/select/filterSelect";
import moment from "moment";
import { FiberManualRecord, SearchOutlined } from "@mui/icons-material";
import InputNewRangePicker from "../../../../components/input/inputRankPicker";
import { ButtonPrimary } from "../../../../components/button/ButtonCustoms";
import { advisorStudentApi } from "../../../../api/advisor-student/advisor-student.api";
import CustomStatus from "../../../../components/chip/CustomStatus";
import {
  allStatusConsultRequestUtil,
  handleColorStatusConsultRequestUtil,
  handleTextStatusConsultRequestUtil,
} from "../../../../utils/statusRequest";
import { dataEvaluation } from "../../../../utils/usage_form_evluation";
import { advisorTypeApi } from "../../../../api/advisor-type/advisor-type.api";

const ListConsultationRequest = () => {
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const step_params = searchParams.get('step');

  const { profile } = useSelector((state: any) => state.profile);

  const [dataAdvisor, setDataAdvisor] = useState<any[]>([]);
  const [dataAdvisorType, setDataAdvisorType] = useState<any[]>([]);

  const [inputValueSearch, setInputValueSearch] = useState({
    keyword: "",
    consultation_type: "",
    advisor_group: "",
    status: "",
  });

  // console.log("inputValueSearch", inputValueSearch);

  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [sortBy, setSortBy] = useState<string>("");
  const [sortType, setSortType] = useState<string>("ASC");

  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [selectedDateRange, setSelectedDateRange] = useState<string[]>([]);
  const handleRangeDate = (value: any) => {
    setSelectedDateRange(value);
    setStartDate(moment(value[0]).format("YYYY-MM-DD"));
    setEndDate(moment(value[1]).format("YYYY-MM-DD"));
  };

  const handleClearRangeDate = () => {
    setSelectedDateRange([]);
    setStartDate("");
    setEndDate("");
  };

  const getAdvisorType = async () => {
    let query: any = {
      page: 1,
      limit: 100000,
    };

    const res = await advisorTypeApi.getAllAdvisorType(query);

    const data = res.data;
    if (data.status < 300) {
      setDataAdvisorType(data.data.items);
    } else {
      setDataAdvisorType([]);
    }
  };

  useEffect(() => {
    getAdvisorType();
  }, []);

  const headCells = [
    {
      id: "request_title",
      width: 50,
      disablePadding: true,
      align: "start",
      label: "เรื่องที่ขอคำปรึกษา",
    },
    {
      id: "request_to",
      disablePadding: true,
      width: 15,
      align: "center",
      label: "อาจารย์ผู้ให้คำปรึกษา",
    },
    {
      id: "advisor_type",
      disablePadding: false,
      align: "center",
      width: 15,
      label: "ประเภทอาจารย์ที่ปรึกษา",
    },
    {
      id: "detail",
      disablePadding: false,
      align: "center",
      width: 50,
      label: "รายละเอียด",
    },
    {
      id: "request_date",
      disablePadding: false,
      align: "center",
      width: 20,
      label: "วันที่ขอคำปรึกษา",
    },
    {
      id: "status",
      disablePadding: false,
      align: "center",
      width: 20,
      label: "สถานะ",
    },
    {
      id: "action",
      disablePadding: false,
      align: "center",
      width: 20,
      label: "action",
    },
  ];

  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const {
      id_advisor_student,
      first_name_advisor,
      last_name_advisor,
      advisor_group,
      advisor_student_detaill,
      first_name_class_emp,
      last_name_class_emp,
      created_date,
      first_name_emp,
      last_name_emp
    } = objData;

    let parsedAdvisorStudentDetail = [];

    try {
      parsedAdvisorStudentDetail = JSON.parse(advisor_student_detaill);
    } catch (error) {
      console.error("Error parsing advisor_student_detaill:", error);
    }

    const objRenderData = {
      key: id_advisor_student,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "start",
          label: parsedAdvisorStudentDetail?.advisor_type_name ?? "-",
        },
        {
          option: "TEXT",
          align: "start",
          label: first_name_class_emp ?
            `${first_name_class_emp || ""} ${last_name_class_emp || ""}`
            : first_name_advisor ? first_name_advisor + " " + last_name_advisor : `${first_name_emp || ""} ${last_name_emp || ""}`,
        },
        {
          option: "TEXT",
          align: "center",
          label: advisor_group ?? "-",
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: parsedAdvisorStudentDetail?.detail ?? "-",
        },
        {
          option: "TEXT",
          align: "center",
          disablePadding: true,
          label: created_date ? dateTimeToView(created_date) : created_date,
        },
        {
          option: "TEXT",
          align: "center",
          // label: parsedAdvisorStudentDetail?.status ?? "-",
          label: (
            <CustomStatus
              label={handleColorStatusConsultRequestUtil(
                parsedAdvisorStudentDetail?.status,
                profile && profile.user_type
              )}
              type="outlined"
              color={handleTextStatusConsultRequestUtil(
                parsedAdvisorStudentDetail?.status
              )}
              icon={<FiberManualRecord />}
              width="250px"
            />
          ),
        },
        {
          option: "TEXT",
          align: "center",
          label: (
            <div
              style={{
                display: "flex",
                textAlign: "center",
                justifyContent: "center",
              }}
            >
              <img
                onClick={() => {
                  navigate({
                    pathname: routeName.student.studentConsultation +
                      `/${id_advisor_student}/update`,
                    search: `${searchParams.toString()}`
                  }
                  );
                }}
                src={icons.eye}
                alt="eye"
                style={{ cursor: "pointer" }}
              />
            </div>
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  const handleChangeValueSearch = (name: string, value: any) => {
    setInputValueSearch((prev: any) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const getDataConsultationRequest = async () => {
    let query: any = {
      page: page,
      limit: pageLimit,
      sortBy: sortBy,
      sortType: sortType,
      status: inputValueSearch.status,
      sdate: startDate,
      edate: endDate,
      advisor_group: inputValueSearch.advisor_group,
      advisorTypeId:
        inputValueSearch.consultation_type === "ทุกเรื่องที่ขอคำปรึกษา"
          ? ""
          : inputValueSearch.consultation_type,
    };

    const res = await advisorStudentApi.getAllAdvisorStudentWithUserLogin(
      query
    );
    const data = res.data;
    if (data.status < 300) {
      setDataAdvisor(data.data?.items);
      setTotalItems(data.data?.meta?.totalItems || 0);
    } else {
      setDataAdvisor([]);
    }
  };

  useEffect(() => {
    getDataConsultationRequest();
  }, [
    page,
    pageLimit,
    sortBy,
    sortType,
    inputValueSearch,
    startDate,
    endDate,
    inputValueSearch.consultation_type,
  ]);

  return (
    <>
      <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
        <article className="w-full col-span-12 lg:col-span-3 md:col-span-3 sm:col-span-12">
          <InputNewRangePicker
            value={selectedDateRange}
            onchange={handleRangeDate}
            onClear={handleClearRangeDate}
            allowClear
          />
        </article>

        <article className="w-full col-span-12 lg:col-span-3 md:col-span-3 sm:col-span-12">
          <FilterSelect
            value={inputValueSearch.consultation_type ?? ""}
            labelId="consultation_type-id"
            selectId="consultation_type-select-id"
            placeholder="เลือกเรื่องที่ขอคำปรึกษา"
            options={[
              {
                id_consultation_type: "",
                consultation_type_name: "ทุกเรื่องที่ขอคำปรึกษา",
              },
              ...dataAdvisorType.map((item, index) => ({
                id_consultation_type: item.consultation_type_name,
                consultation_type_name: item.advisor_type_name,
              })),
            ].map((list, index) => (
              <MenuItem value={list.consultation_type_name} key={index + 1}>
                {list.consultation_type_name}
              </MenuItem>
            ))}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChangeValueSearch("consultation_type", e.target.value)
            }
          />
        </article>

        <article className="w-full col-span-12 lg:col-span-2 md:col-span-3 sm:col-span-12">
          <FilterSelect
            value={inputValueSearch.advisor_group ?? ""}
            labelId="advisor_group-id"
            selectId="advisor_group-select-id"
            options={[
              {
                id_advisor_group: "",
                advisor_group_name: "ทุกประเภทอาจารย์ที่ปรึกษา",
              },
              ...dataEvaluation.map((item, index) => ({
                id_advisor_group: item.id,
                advisor_group_name: item.name,
              })),
            ].map((list, index) => (
              <MenuItem value={list.id_advisor_group} key={index + 1}>
                {list.advisor_group_name}
              </MenuItem>
            ))}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChangeValueSearch("advisor_group", e.target.value)
            }
          />
        </article>

        <article className="w-full col-span-12 lg:col-span-2 md:col-span-3 sm:col-span-12">
          <FilterSelect
            value={inputValueSearch.status ?? ""}
            labelId="status-id"
            selectId="status-select-id"
            options={[
              {
                id_status: "",
                status_name: "ทุกสถานะ",
              },
              ...allStatusConsultRequestUtil.map((item) => ({
                id_status: item,
                status_name: handleColorStatusConsultRequestUtil(
                  item,
                  profile && profile.user_type
                ),
              })),
            ].map((list, index) => (
              <MenuItem value={list.id_status} key={index + 1}>
                {list.status_name}
              </MenuItem>
            ))}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChangeValueSearch("status", e.target.value)
            }
          />
        </article>

        <article
          className="w-full col-span-12 lg:col-span-2 md:col-span-4 sm:col-span-12"
          style={{
            display: "flex",
            justifyContent: "end",
          }}
        >
          <ButtonPrimary
            onClick={() => {
              navigate({ pathname: routeName.student.studentConsultation + `/create`, search: `${searchParams.toString()}` });
            }}
            mode="send_request"
            buttonName={"ส่งเรื่องขอคำปรึกษา"}
          />
        </article>
      </div>
      <section className="w-full mt-10">
        <TableCustom
          tableMinWidth={1400}
          tableFixedWidth
          customScroll
          page={page}
          pageLimit={pageLimit}
          sortBy={sortBy}
          sortType={sortType}
          headCells={headCells}
          rowCount={totalItems}
          rowsData={
            dataAdvisor &&
            dataAdvisor.map((data: any, i: any) => {
              return renderData(data, i);
            })
          }
          onSort={() => { }}
          setPageLimit={(value: number) => setPageLimit(value)}
          setPage={(value: number) => setPage(value)}
        />
      </section>
    </>
  );
};

export default ListConsultationRequest;
